import PropTypes from 'prop-types';

const OutlineItemTitle = ({
  icon,
  title,
  screenreaderMessage,
  subtitle,
  fontWeight,
}) => (
  <div
    className={`outline-item-row ${subtitle && 'fixed-height'}`}
  >
    <div>
      {icon}
    </div>
    <div className="outline-item-title-wrapper">
      <div className="hideOverflow">
        <span
          className={`small ${fontWeight}-weight`}
        >
          {title}
        </span>
        <span className="sr-only">
          , {screenreaderMessage}
        </span>
      </div>
      {subtitle && (
        <span className="micro">
          {subtitle}
        </span>
      )}
    </div>
  </div>
);

OutlineItemTitle.defaultProps = {
  subtitle: null,
  fontWeight: 'normal',
};

OutlineItemTitle.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  screenreaderMessage: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  fontWeight: PropTypes.string,
};

export default OutlineItemTitle;
